import { App } from '../App';
import { Response as Application } from 'api/typegen/client/application/get';
import {
  ProductNumberKind,
  ProductNumberKindAvailables,
} from 'api/typegen/client/get';

// Returns the numeric product ID matching the kind stored in sessionStorage at login
export function getClientProductNumber(
  availableProducts?: ProductNumberKind[],
): string {
  const productNumberFromBE =
    availableProducts &&
    availableProducts.find((data) => data.kind === App.config.productKind);

  return productNumberFromBE?.number || App.config.productNumber;
}

// Returns the numeric product ID for a given kind from the client's available products
export const getProductNumber = (
  productAvailables: ProductNumberKindAvailables | undefined,
  productKind: string | null | undefined,
) => {
  const productData = productAvailables?.find(
    (data) => data.kind === productKind,
  );
  return productData?.number || App.config.productNumber;
};

export const getProductKind = (
  productAvailables: ProductNumberKindAvailables | undefined,
  productKind: string | null | undefined,
) => {
  return productAvailables?.find((data) => data.kind === productKind);
};

// Checks whether a given product kind exists in the client's available products
export const isProductKindAvailable = (
  productAvailables: ProductNumberKindAvailables | undefined,
  productNumberkind: string | null,
) => Boolean(getProductNumber(productAvailables, productNumberkind));

export const isProductKind = (
  data: Application | null | undefined,
  productNumberKind: string,
) => Boolean(data?.productInfo?.kind === productNumberKind);
